import { connect } from 'react-redux';

import { Notifications } from '../../../../common/notifications/Notifications';
import { IAppState } from '../../../models/reduxState';
import { dispatchDismissUserNotice, dispatchOnNotificationsRender } from '../reduxUpdater/dispatchers/contactUsDispatchers';
import { notificationsSelector } from '../reduxUpdater/selectors/sharedStateSelectors';
import { getTheme } from '../styles/themes';

const mapDispatchToProps = {
  onRender: dispatchOnNotificationsRender,
  onDismiss: dispatchDismissUserNotice,
};

const mapStateToProps = (state: IAppState) => {
  return {
    notifications: notificationsSelector(state),
    theme: getTheme(state),
    sanitize: true,
    useExtendPalette: true,
  };
};

export const FormNoticeListContainer = connect(mapStateToProps, mapDispatchToProps)(Notifications);
